import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import {
  generateUniqueNumber,
  updateObjectInArray,
} from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import ProductColourForm from "../../../components/forms/setup/productColours/ProductColourForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";

export function ProductColoursViewModel(addSnackbar, logout) {
  const [loading, setLoading] = useState(false);
  const [productColours, setProductColours] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getProductColours = async function (search, page) {
    setLoading(true);

    let callResult = await makeGetApiCall(
      `productColours?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setProductColours(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const createColour = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("productColours/create", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getProductColours("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateColour = async function (values, index) {
    let callResult = await makePutApiCall(
      `productColours/${values.id}`,
      values
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...productColours.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setProductColours({ ...productColours, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddNewSlideOver = (isEdit, colour, index) => {
    setSlideOver({
      childComponent: (
        <ProductColourForm
          colour={colour}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateColour(payload, index) : createColour(payload)
          }
          title={isEdit ? `Update ${colour.name}` : "Add new colour"}
          inProgress={false}
        />
      ),
      open: true,
    });
  };

  const deleteColour = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteProductColour/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = productColours.data.filter((item) => item.id !== id);
      setProductColours({ ...productColours, data: newItems });

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDelete = function (colour, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteColour(colour.id, index)}
          message={`Are you sure you want to delete ${colour.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddNewSlideOver,
    getProductColours,
    loading,
    productColours,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDelete,
  };
}
